import { useState } from 'react';
import { useSelector } from 'react-redux';
import {
	calculateDateProgress,
	formatDate,
} from '../../../common/formatDateText';
import { CreditCardIcon } from '@heroicons/react/24/outline';
import { DrawerPaymentStudent } from '../../payments/drawerPaymentStudent/DrawerPaymentStudent';

export const SliderDayPayment = () => {
	const { user } = useSelector((state) => state.user);
	const { paymentDeadlineDate, lastDatePayment, _id: userId, statusSubscription } = user;
	const [isOpenDrawerPayment, setIsOpenDrawerPayment] = useState(false);

	const toggleDrawerPayment = () => {
		setIsOpenDrawerPayment(!isOpenDrawerPayment);
	};


	return (
		<div className='w-full'>
			<div className="flex items-center justify-between mb-4">
				<div className="flex items-center gap-3">
					<div>
						<h1 className="text-xl font-bold text-gray-900 tracking-tight">Tu suscripción</h1>
						<p className="text-xs text-gray-500 font-medium">Estado de tu cuenta</p>
					</div>
				</div>
				<div className={`
					px-4 py-1 rounded-md text-[.9rem] font-bold uppercase border-[1px]
					${statusSubscription === 'pagado'
						? 'bg-emerald-100 text-emerald-500 border-emerald-200'
						: 'bg-rose-100 text-rose-500 border-rose-200'
					}
				`}>
					<div className="flex items-center gap-1.5">
						<span className={`relative flex h-2 w-2 mr-1`}>
							{statusSubscription === 'pagado' && (
								<span className={`animate-ping absolute inline-flex h-full w-full rounded-full ${statusSubscription === 'pagado' ? 'bg-emerald-500' : 'bg-rose-500'} opacity-75`}></span>
							)}
							<span className={`relative inline-flex rounded-full h-2 w-2 ${
								statusSubscription === 'pagado' ? 'bg-emerald-500' : 'bg-rose-500'
							}`}></span>
						</span>
						<span className="text-[.9rem]">
							{statusSubscription}
						</span>
					</div>
				</div>
			</div>
			<div className="flex items-start gap-4 pt-4 border-t border-gray-200">
				{/* Círculo de progreso */}
				{(() => {
					const progress = Math.min(calculateDateProgress(new Date(lastDatePayment || new Date()), new Date(paymentDeadlineDate)), 100);
					// const progress = 25;
					const radius = 26;
					const circumference = 2 * Math.PI * radius;
					const strokeDashoffset = circumference * (1 - progress / 100);

					// Determinar color según el porcentaje
					let strokeColor, iconBgColor;
					if (progress < 30) {
						strokeColor = '#10B981'; // emerald-500
						iconBgColor = 'bg-emerald-500';
					} else if (progress < 70) {
						strokeColor = '#EAB308'; // yellow-500
						iconBgColor = 'bg-yellow-500';
					} else if (progress < 100) {
						strokeColor = '#F97316'; // orange-500
						iconBgColor = 'bg-orange-500';
					} else {
						strokeColor = '#F43F5E'; // rose-500
						iconBgColor = 'bg-rose-500';
					}

					return (
						<div className="relative flex-shrink-0">
							<svg className="w-24 h-24 transform -rotate-90" viewBox="0 0 64 64">
								{/* Círculo de fondo */}
								<circle
									cx="32"
									cy="32"
									r={radius}
									fill="none"
									stroke="#F3F4F6"
									strokeWidth="6"
								/>
								{/* Círculo de progreso */}
								<circle
									cx="32"
									cy="32"
									r={radius}
									fill="none"
									stroke={strokeColor}
									strokeWidth="6"
									strokeDasharray={circumference}
									strokeDashoffset={strokeDashoffset}
									strokeLinecap="round"
								/>
							</svg>
							{/* Icono de tarjeta de crédito en el centro */}
							<div className="absolute inset-0 flex items-center justify-center">
								<div className={`w-10 h-10 ${iconBgColor} rounded-full flex items-center justify-center shadow-md`}>
									<CreditCardIcon className="w-6 h-6 text-white" />
								</div>
							</div>
						</div>
					);
				})()}

				{/* Información de fecha */}
				<div className="flex flex-col items-start">
					<div className="flex items-center mb-2">
						<span className="text-sm text-gray-500 font-medium">Proxima fecha de pago</span>
					</div>
					<span className="text-lg font-bold text-gray-900 mb-1 capitalize">
						{formatDate(paymentDeadlineDate)}
					</span>
					<button
						onClick={toggleDrawerPayment}
						className="inline-block text-[.9rem] font-bold text-indigo-600 hover:text-indigo-700 transition-colors"
					>
						Ir pagar
					</button>
				</div>
			</div>

			{/* Drawer de pagos */}
			<DrawerPaymentStudent
				isOpenDrawerPayment={isOpenDrawerPayment}
				toggleDrawerPayment={toggleDrawerPayment}
				userId={userId}
			/>
		</div>
	)
}
